Bingo.LanguageSwitch = {};

Bingo.LanguageSwitch.init = function inti() {
    getParameter = function (name, url) {
        const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    $('.js-language-switch').on('click', function click() {
        $(this).attr('href', (i, a) => {
            const code = getParameter('mainMenu-code', a);
            const doParam = getParameter('do', a);
            const anchorPosition = window.location.href.search('#');
            let url = window.location.href;
            if (anchorPosition > 0) {
                url = window.location.href.substr(0, anchorPosition);
            }
            let startSeparator = '&';
            if (window.location.search.length === 0) {
                startSeparator = '?';
            }
            return `${url}${startSeparator}mainMenu-code=${code}&do=${doParam}`;
        });
    });
};

Bingo.LanguageSwitch.init();
